import React, { useState } from 'react';
/* global axios */
import api from '../services/apiService';
import moment from 'moment';

const CreateTourForm = ({ vehicle, selectedDate, onTourCreated, onCancel, drivers }) => {
  const [tourName, setTourName] = useState('');
  // Wir speichern die Zeiten als String im Format "HH:mm"
  const [timeframeFrom, setTimeframeFrom] = useState('');
  const [timeframeTo, setTimeframeTo] = useState('');
  const [driverId, setDriverId] = useState('');
  const [notes, setNotes] = useState('');


  const isDriverAvailable = (driver, date) => {
    // Falls keine Abwesenheiten vorhanden sind, ist der Fahrer verfügbar.
    if (!driver.absences || driver.absences.length === 0) return true;
    
    const selectedDate = moment(date).startOf('day');
    
    // Prüfe, ob das ausgewählte Datum in irgendeiner Abwesenheit (Urlaub oder Krank) liegt.
    return !driver.absences.some(absence => {
      const absenceStart = moment(absence.startDate).startOf('day');
      const absenceEnd = moment(absence.endDate).endOf('day');
      return (absence.type === 'urlaub' || absence.type === 'krank') &&
             selectedDate.isBetween(absenceStart, absenceEnd, null, '[]');
    });
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        tourName,
        scheduledDate: moment(selectedDate).format('YYYY-MM-DD'),
        // Zeitwerte sind direkt im "HH:mm" Format
        timeframeFrom,
        timeframeTo,
        vehicleId: vehicle.id,
        driverId: driverId || null,
        notes,
      };
      const response = await api.post('/transports/createTour', payload);
      console.log('Tour erstellt:', response.data);
      onTourCreated(response.data);
    } catch (error) {
      console.error('Fehler beim Erstellen der Tour:', error);
    }
  };

  return (
    <div>
      <h3>Neue Tour für {vehicle.name}</h3>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Tourname:</label>
          <input 
            type="text" 
            value={tourName} 
            onChange={(e) => setTourName(e.target.value)} 
            required 
          />
        </div>
        <div>
          <label>Zeitraum von:</label>
          <input 
            type="time" 
            value={timeframeFrom} 
            onChange={(e) => setTimeframeFrom(e.target.value)}
            required 
          />
        </div>
        <div>
          <label>Zeitraum bis:</label>
          <input 
            type="time" 
            value={timeframeTo} 
            onChange={(e) => setTimeframeTo(e.target.value)}
            required 
          />
        </div>
        <div>
          <select 
            value={driverId} 
            style={{
              padding: '10px',
              borderRadius: '0px',
              border: '1px solid #ccc',
              width: '250px',
              marginLeft: '0px',
            }}
            onChange={(e) => setDriverId(e.target.value)}
          >
            <option value="">-- Fahrer wählen --</option>
            {drivers.filter(driver => driver.role === 'Fahrer' && isDriverAvailable(driver, selectedDate)).map(driver => (
              <option key={driver.id} value={driver.id}>
                {driver.firstName} {driver.lastName}
              </option>
            ))}
          </select>
        </div>
        
        <button type="submit">Tour anlegen</button>
        <button type="button" onClick={onCancel}>Abbrechen</button>
      </form>
    </div>
  );
};

export default CreateTourForm;
